<template>
  <div class="w-100">
    <div
      v-if="folder && !isLoading"
      class="d-flex position-relative align-items-center bg-light py-2 px-2 rounded mb-3 cursor-pointer"
      @click="$emit('click', folder)"
    >
      <i class="mdi mdi-folder mdi-18px mr-2"/>
      <h6
        class="m-0 p-0"
        style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden"
      >
        {{ folder.name }}
      </h6>
      <div v-if="!defaultMode" class="bg-light position-absolute" style="border-radius: 0 3px 0 3px; top: 0; right: 0;">
        <b-dropdown
          size="sm"
          toggle-class="btn-rounded-2 text-decoration-none bg-light border-0"
          variant="light"
          no-caret
        >
          <template #button-content>
            <i class="bx bx-dots-vertical text-semi-light"/>
          </template>
          <b-dropdown-item-button>
            <div class="d-flex align-items-center" @click="$emit('clickRename', folder)">
              <i class="bx bx-edit-alt mr-1"/>
              <div>Renommer</div>
            </div>
          </b-dropdown-item-button>
          <b-dropdown-item-button>
            <div class="d-flex align-items-center" @click="$emit('clickDelete', folder)">
              <i class="bx bx-trash-alt mr-1"/>
              <div>Supprimer</div>
            </div>
          </b-dropdown-item-button>
        </b-dropdown>
      </div>
    </div>
    <div v-if="isLoading">
      <vue-content-loading :height="100" class="mb-3 w-100">
        <rect x="0" y="0" rx="10" ry="10" width="100%" height="100%"/>
      </vue-content-loading>
    </div>
  </div>
</template>

<script>
import VueContentLoading from 'vue-content-loading'

export default {
  name: "folder",

  components: {
    VueContentLoading,
  },

  props: {
    folder: {
      type: Object,
      default: null,
    },
    userMe: {
      type: String,
      default: '',
    },
    defaultMode: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean, 
      default: true,
    },
  },
}
</script>

<style scoped>

</style>